import { render, staticRenderFns } from "./assistant_cloud_notice.vue?vue&type=template&id=4331bc52&scoped=true&"
import script from "./assistant_cloud_notice.vue?vue&type=script&lang=js&"
export * from "./assistant_cloud_notice.vue?vue&type=script&lang=js&"
import style0 from "./assistant_cloud_notice.vue?vue&type=style&index=0&id=4331bc52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4331bc52",
  null
  
)

export default component.exports